// extracted by mini-css-extract-plugin
export default {"InputContainer":"style_InputContainer__VVTU4"};